import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativePortionsMAY: typeof valueTypeRenderers.chillCumulativePortionsMAY = {
  label: () => unitConverter.chillCumulativePortionsMAY().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillCumulativePortionsMAY().title(),
      render: (n) => unitConverter.chillCumulativePortionsMAY(n).valueAsString(),
    }),
}
